// extracted by mini-css-extract-plugin
export var button = "injectable-slider-module--button--wb51f";
export var container = "injectable-slider-module--container--WE5w6";
export var icon = "injectable-slider-module--icon--K9BX-";
export var imgBox = "injectable-slider-module--img-box--pkuUr";
export var sliderBox = "injectable-slider-module--slider-box--F5t-4";